export const PicturesSliderMap = [
  {
    id: 1,
    src: './img/banner-phones.png',
    title: 'phones',
  },
  {
    id: 2,
    src: './img/banner-tablets.png',
    title: 'tablets',
  },
  {
    id: 3,
    src: './img/banner-accessories.png',
    title: 'accessories',
  },
];
